
import {
	SET_PROGRESS_MESSAGE,
	SET_PROGRESS_PERCENTAGE,
} from '../models/actions/AppActions';
import AppGlobals from '../AppGlobals';


export function setProgressMessage(message) {
	const Store = AppGlobals.redux;
	Store.dispatch({
		type: SET_PROGRESS_MESSAGE,
		message,
	});
}
export function setProgressPercentage(percentage) {
	const Store = AppGlobals.redux;
	Store.dispatch({
		type: SET_PROGRESS_PERCENTAGE,
		percentage,
	});
}